module.exports = __webpack_public_path__ + "media/images/svgs/icon-check-c16449744e8d58a5692059808649f6ba.svg";